var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationsMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5C10.3545 0.504136 6.85958 1.95412 4.28185 4.53185C1.70412 7.10958 0.254136 10.6045 0.25 14.25C0.25 26.0156 12.75 34.9062 13.2812 35.2812C13.4942 35.423 13.7442 35.4986 14 35.4986C14.2558 35.4986 14.5058 35.423 14.7188 35.2812C15.25 34.9062 27.75 26.0156 27.75 14.25C27.7459 10.6045 26.2959 7.10958 23.7182 4.53185C21.1404 1.95412 17.6455 0.504136 14 0.5ZM14 9.25C14.9889 9.25 15.9556 9.54325 16.7779 10.0927C17.6001 10.6421 18.241 11.423 18.6194 12.3366C18.9978 13.2502 19.0969 14.2555 18.9039 15.2255C18.711 16.1954 18.2348 17.0863 17.5355 17.7855C16.8363 18.4848 15.9454 18.961 14.9755 19.1539C14.0055 19.3469 13.0002 19.2478 12.0866 18.8694C11.173 18.491 10.3921 17.8501 9.84265 17.0279C9.29325 16.2056 9 15.2389 9 14.25C9 12.9239 9.52678 11.6521 10.4645 10.7145C11.4021 9.77678 12.6739 9.25 14 9.25Z",
    fill: "#5F3B0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsMarker);
export default __webpack_public_path__ + "static/media/LocationsMarker.d9081b61a7d485a771b100030bd89f67.svg";
export { ForwardRef as ReactComponent };